import { isOwner } from '../../auth/roles';
import { useSession } from '../../auth/useSession';
import { useCapability } from '../../lib/useCapability';

/** Inteligencia is for owners whose plan includes it (Max and up) or who had it switched on by Dale. */
export function useIntelligenceAccess(): boolean {
  const { session } = useSession();
  const opens = useCapability('inteligencia');
  return isOwner(session?.role) && opens;
}
